import { useQuery } from "@apollo/client/react";
import { Carousel } from "react-bootstrap";
import Spinner from "react-bootstrap/esm/Spinner";
import { GetCampsitePhotosDocument } from "../types/graphql/graphql";

type Props = {
  campsiteId: number;
};

export default function CampsitePhotos({ campsiteId }: Props) {
  const { data, loading } = useQuery(GetCampsitePhotosDocument, { variables: { campsiteId } });
  const photos = data?.campsite?.photos?.filter((photo) => !!photo.src);

  if (loading) return <Spinner className="d-block mx-auto my-5" />;

  return photos && photos.length > 0 ? (
    <Carousel>
      {photos.map((photo) => (
        <Carousel.Item key={photo.id}>
          <img
            src={photo.src as string}
            alt={photo.caption || ""}
            style={{ height: "40rem" }}
            className="object-fit-cover w-100"
          />
          <Carousel.Caption>
            <h3>{photo.caption}</h3>
          </Carousel.Caption>
        </Carousel.Item>
      ))}
    </Carousel>
  ) : null;
}
